export default __webpack_public_path__ + "static/media/userGood.fab5df0d.svg";